import React, { Component } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { RotateLoader } from "react-spinners";

export class FormServiceType extends Component {
  state = {
    loading: true,
  };

  componentDidMount = () => {
    console.log("FormServiceType");
    console.log(this.props.values);
    if (!this.props.values.serviceTypeRequired) {
      console.log("Skipping as ServiceType Not Required");
      this.props.handleChange({
        serviceType: "OTHER",
      });
      this.props.nextStep();
    } else if (this.props.values.paramServiceType !== null) {
      this.props.handleChange({
        serviceType: this.props.values.paramServiceType,
      });
      this.props.nextStep();
    } else {
      this.setState({
        loading: false,
      });
    }
  };

  oilChange = (e) => {
    this.props.handleChange({
      serviceType: "OIL_CHANGE",
    });
    this.props.nextStep();
  };

  other = (e) => {
    this.props.handleChange({
      serviceType: "OTHER",
    });
    this.props.nextStep();
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    return (
      <React.Fragment>
        <h3>Service Type</h3>
        <hr />
        <Row>
          <Col>
            {!this.state.loading && (
              <React.Fragment>
                <h3>What are you here for ?</h3>
                <Form onSubmit={this.continue}>
                  <Button size="lg" block variant="primary" type="button" onClick={this.oilChange}>
                    Oil Change
                  </Button>
                  <Button size="lg" block variant="primary" type="button" onClick={this.other}>
                    Maintenance / Something Else
                  </Button>
                </Form>
              </React.Fragment>
            )}
            <div className="text-center loader">
              <RotateLoader color={"#337ab7"} loading={this.state.loading} />
            </div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

export default FormServiceType;
